import { path, pathOr } from 'ramda';
import { e164 } from 'utilities/telephoneFormatter';

export const imageUrl = superhuggg =>
  path(['purchase', 'image_url'], superhuggg);

export const brandId = superhuggg =>
  path(['purchase', 'brand', 'id'], superhuggg);

export const transformSuperhuggg = superhuggg => ({
  huggg: superhuggg || {},
  brand: pathOr({}, ['purchase', 'brand'], superhuggg),
  locations: null
});

export const claimRestrictionsValidator = (
  superhuggg,
  claimMethod = 'sms'
) => value => {
  if (
    !superhuggg.claim_restrictions &&
    !superhuggg.claim_restrict_personal_emails
  ) {
    return true;
  }

  if (!value) {
    return false;
  }

  const formatted = claimMethod === 'sms' ? e164(value) : value.toLowerCase();

  if (superhuggg.claim_restrictions) {
    for (const restriction of superhuggg.claim_restrictions) {
      if (claimMethod === 'sms') {
        if (formatted.startsWith(restriction)) {
          return true;
        }
      } else if (claimMethod === 'email') {
        if (formatted.endsWith(restriction.toLowerCase())) {
          return true;
        }
      }
    }

    // The input did not match any restrictions so return invalid
    return false;
  }

  if (superhuggg.claim_restrict_personal_emails && claimMethod === 'email') {
    const personalEmailDomains = [
      'aol.com',
      'gmail.com',
      'googlemail.com',
      'hotmail.co.uk',
      'hotmail.com',
      'icloud.com',
      'live.co.uk',
      'live.com',
      'mail.com',
      'msn.com',
      'outlook.com',
      'protonmail.com',
      'yahoo.co.uk',
      'yahoo.com',
      'zoho.com'
    ];

    for (const personalEmailDomain of personalEmailDomains) {
      if (formatted.endsWith(personalEmailDomain)) {
        // This is a personal email domain, so we should return invalid
        return false;
      }
    }
  }

  return true;
};
